interface RadioButtonIconProps {
  strokeColor: string;
  checkedColor?: string;
  checked?: boolean;
}

export const RadioButtonIcon = (props: RadioButtonIconProps) => {
  const isChecked = props.checked ?? false;
  const checkedColor = props.checkedColor ?? "inherit";
  return (
    <svg width="1.5rem" height="1.5rem" viewBox="0 0 24 24" fontSize="1.5rem">
      <circle cx="50%" cy="50%" r="0.75rem" stroke={props.strokeColor} stroke-width="1px" fill="none" />
      {isChecked && <circle cx="50%" cy="50%" r=".4375rem" fill={checkedColor} />}
    </svg>
  );
};
